// Node
import { difference, intersection, pluck } from 'underscore';

import axios from 'axios';
import $ from 'jquery';
import { filtersToQuery, mergeCamps, sortForMap, zIndexForMapMarker } from '../filter_utils';
import { getTariffData } from '../new_design/common/map/tariff_utils';

export default class Map extends React.Component {
  constructor(props) {
    super(props);
    this.loadCamps = this.loadCamps.bind(this);
    this.initMarkers = this.initMarkers.bind(this);
    this.refreshMap = this.refreshMap.bind(this);
    this.filterCampsInBorder = this.filterCampsInBorder.bind(this);
    this.handleMapClick = this.handleMapClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlePopstate = this.handlePopstate.bind(this);
    this.handleLoadCamps = this.handleLoadCamps.bind(this);
    this.state = {
      balloonCamp: null,
      balloonX: 0,
      balloonY: 0,
      loadingCamps: false,
      campsInBorders: [],
      allCamps: [],
      camps: [],
      calculated_camps_ids: [],
      loadedFilters: {},
      mapMoved: false,
      loadingYScript: true,
    };
    this.mapCanvasRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ loadingYScript: true });

    if (typeof ymaps3 == 'undefined') {
      let script = document.createElement('script');

      script.onload = () => {
        ymaps3.ready.then(() => {
          this._initMap();
        });
      };

      script.src = $('#ymaps-lazy-script').data('src');
      document.getElementsByTagName('head')[0].appendChild(script);
    } else {
      ymaps3.ready.then(() => {
        this._initMap();
      });
    }
  }

  loadCamps(mapMoved = false) {
    if (!this.map || !this.map.bounds) return;
    const [[minLng, minLat], [maxLng, maxLat]] = this.map.bounds;

    let url = '/map_camps';
    const { string } = filtersToQuery(this.props.filters, 0, false, this.props.s_params, null, false);
    let search_data = JSON.parse($.cookie('search_data'));
    search_data.date_start = this.props.s_params.date_start;
    search_data.date_end = this.props.s_params.date_end;
    search_data.count_guests = this.props.s_params.count_guests;
    search_data.children_ages = this.props.s_params.children_ages;
    $.cookie('search_data', JSON.stringify(search_data), { path: '/', expires: 60 });
    url += '?';
    url += new URLSearchParams(search_data).toString();
    if (this.props.city_id) url += `&city_id=${this.props.city_id}`;
    if (this.props.country_id) url += `&country_id=${this.props.country_id}`;
    url += `&${string}`;
    this.setState({ loadingCamps: true });
    this.abortController = new AbortController();
    const data = {
      exclude_ids: this.state.calculated_camps_ids,
      map_moved: mapMoved,
      river_id: this.props.river_id,
      region_id: this.props.region_id,
      min_lng: minLng,
      max_lng: maxLng,
      min_lat: minLat,
      max_lat: maxLat,
    };
    if (this.props.s_params.date_start) {
      axios
        .post(
          url,
          { ...data, load_integrations: false },
          {
            signal: this.abortController.signal,
          }
        )
        .then((res) => {
          this.handleLoadCamps(res.data, true);

          // data.exclude_ids = [...data.exclude_ids, ...res.data.camps.map((c) => c.id)];

          axios
            .post(
              url,
              { ...data, load_mt: false },
              {
                signal: this.abortController.signal,
              }
            )
            .then((res) => this.handleLoadCamps(res.data))
            .catch((error) => {
              if (error.name === 'CanceledError') return;
              console.error(error);
            });
        })
        .catch((error) => {
          if (error.name === 'CanceledError') return;
          console.error(error);
        });
    } else {
      axios
        .post(
          url,
          { ...data },
          {
            signal: this.abortController.signal,
          }
        )
        .then((res) => {
          this.handleLoadCamps(res.data);
        })
        .catch((error) => {
          if (error.name === 'CanceledError') return;
          console.error(error);
        });
    }
  }

  handleLoadCamps(data, loadingMore = false) {
    const newHtmlParams = data.html_params;
    newHtmlParams.filters_counts ??= this.props.map_html_params?.filters_counts;
    this.props.updateHtmlParams(newHtmlParams);
    this.setState(
      (prevState) => {
        const totalGuestsCount =
          this.props.totalGuestsCount ??
          (this.props.s_params?.count_guests ?? 0) + (this.props.s_params?.children_ages?.length ?? 0);
        let { camps, changed } = mergeCamps(prevState.allCamps, data.camps, totalGuestsCount);
        const newHtmlParams = data.html_params;
        newHtmlParams.filters_counts ??= prevState.html_params?.filters_counts;
        return {
          allCamps: camps,
          camps: camps,
          html_params: data.html_params,
          calculated_camps_ids: [...prevState.calculated_camps_ids, ...data.calculated_camps_ids],
        };
      },
      () => {
        const campsInBorders = this.filterCampsInBorder(this.state.camps);
        this.setState({ loadingCamps: loadingMore, campsInBorders: campsInBorders });
        this.props.onChangeMapCampsLoaded(true);
        this.initMarkers(campsInBorders);
        this.refreshMap();
      }
    );
  }

  filterCampsInBorder(camps) {
    if (!this.map?.bounds) return [];
    const [[minLng, maxLat], [maxLng, minLat]] = this.map.bounds;

    const res = camps.filter((camp) => {
      return camp.longitude >= minLng && camp.longitude <= maxLng && camp.latitude >= minLat && camp.latitude <= maxLat;
    });

    return sortForMap(res, this.props.camp?.id).slice(0, +this.campsToShowCount + 1 || undefined);
  }

  initMarkers(items) {
    let needle1;
    let marker;
    $('body').on('click', 'div.camp-card .onmap', function () {
      const url = $(this).data('link');
      return window.open(url, '_blank');
    });

    if (!this.markers) this.markers = [];
    if (!this.markerIds) this.markerIds = [];

    const intersected = intersection(this.markerIds, pluck(items, 'id'));
    const to_delete = difference(this.markerIds, intersected);
    const to_init = difference(pluck(items, 'id'), intersected);

    for (marker of Array.from(this.markers)) {
      if (to_delete.includes(marker._campId)) {
        this.map.removeChild(marker);
      }
    }

    this.markerIds = difference(this.markerIds, to_delete);
    this.markers = this.markers.filter((marker) => ((needle1 = marker._campId), this.markerIds.includes(needle1)));

    for (let item of Array.from(items)) {
      if (to_init.includes(item.id)) {
        marker = this.createMarker(item);
        this.markerIds.push(item.id);
        this.markers.push(marker);
        this.map.addChild(marker);
      }
    }

    this.initMarkerEventListeners();
  }

  openBalloon(marker, delay) {
    this.hoverTimeout = setTimeout(() => {
      this.mouseOnMarker = true;
      this.paintCanvasMarker(marker);
      const camps = this.state.allCamps;
      let camp = camps.find((camp) => camp.id == marker._campId);
      if (!camp) return;

      if (camp && camp.min_apartment_price == null) {
        axios.get(`/camps/${marker._campId}/min_apartment_price.json?${this.props.htmlParams}`).then((data) => {
          data = data.data;
          camp.min_apartment_price = data.min_apartment_price;
          camp.price_loaded = true;
          this.setState({ allCamps: camps, balloonCamp: camp });
          if (this.mouseOnMarker) {
            this.paintCanvasMarker(marker);
          }
        });
      }
    }, delay);
  }

  refreshMap(markers_to_update = null) {
    const markers = markers_to_update ?? this.markers;
    for (let marker of markers) {
      const needle = marker._campId;
      const camp = this.state.allCamps.find((item) => item.id === needle);

      if (!camp) continue;

      const isCentered = camp.id === this.props.mapCampId || needle === this.state.balloonCamp?.id;

      marker.update({
        zIndex: zIndexForMapMarker(camp, this.props.mapCampId, isCentered),
      });
      marker.element.innerHTML = this.generateMarkerLayout(camp, true, isCentered);
    }
  }

  markerIcon(item, selected = false) {
    let iconClass = '';

    if (this.props.favorites.includes(item.id)) {
      iconClass = selected ? 'unfavorite-icon selected' : 'unfavorite-icon';
    } else if (item.is_can_instant_booking) {
      const baseClass = selected ? 'icon-flash_white' : 'icon-instant-fill';
      iconClass = `icon ${baseClass} ${baseClass}-dims`;
    }

    return `<div id="placemark-icon" class='${iconClass}'></div>`;
  }

  discountIcon(discount, selected) {
    if (!discount) return '';
    return `<div class='discount-icon ${selected ? 'selected' : ''}'></div>`;
  }

  generateMarkerLayout(camp, suitable = false, selected = false) {
    const { priceMin, discount } = getTariffData(camp);
    let classes = 'placemark_layout_container';
    if (!suitable) classes += ' not_suitable';
    if (selected) classes += ' selected';
    classes += priceMin > 0 ? ' wide' : ' empty';

    const icon = this.markerIcon(camp, selected);

    return `<div class="${classes}" data-camp-id="${camp.id}">
         ${icon}
         ${priceMin > 0 ? Math.floor(priceMin).toLocaleString('ru-RU') + ' ₽' : '•'}
         ${this.discountIcon(discount, selected)}
       </div>`;
  }

  createMarker(camp) {
    const el = document.createElement('div');
    el.innerHTML = this.generateMarkerLayout(camp);

    const marker = new this.YMapMarker(
      {
        coordinates: [camp.longitude, camp.latitude],
        zIndex: zIndexForMapMarker(camp, this.props.camp?.id),
      },
      el
    );

    marker._campId = camp.id;
    marker._url = camp.seo_path;
    marker._element = el;
    marker._camp = camp;

    return marker;
  }
}
